import React from "react";
import UserProfile from "../../../../Components/Profile/UserProfile";

const Common_Profile = () => {
  return <UserProfile />;
};

export default Common_Profile;
